import type { SVGProps } from 'react';
const SvgAirlineSeatFlat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#airline_seat_flat_svg__a)">
      <path
        fill="currentColor"
        d="M22 11v2H9V7h9c2.21 0 4 1.79 4 4ZM2 14v2h6v2h8v-2h6v-2H2Zm5.14-1.9a3 3 0 0 0-.04-4.24 3 3 0 0 0-4.24.04 3 3 0 0 0 .04 4.24 3 3 0 0 0 4.24-.04Z"
      />
    </g>
    <defs>
      <clipPath id="airline_seat_flat_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAirlineSeatFlat;
